const ZENDESK_EXAMPLE_KEY = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx';

const ZENDESK_EXAMPLE_SCRIPT = `<! -- Start of Zendesk Widget script -->
<script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_EXAMPLE_KEY}"> </script>
<!--- End of Zendesk Widget script -->`;

export { ZENDESK_EXAMPLE_KEY, ZENDESK_EXAMPLE_SCRIPT };
